import { SET_EDITROUTE } from '../actions';

const routeedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITROUTE:
      return [...action.value];  
    default: return state;
  }
}

export default routeedit;
